(ns app.front.view.group.admin.inspections.inspection-phases
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [app.front.view.group.admin.feature-toggle :as feature-toggle]
            [app.front.view.group.admin.subs :as gas]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]))


(def selectable-phases
  [:group.feature/application-inspections :group.feature/execution-inspections])


(defn available-phases
  "Inspection phases that can be configured for a group with `permit-types`.
  Execution-only products (e.g. enforcement, public work orders) never reach an
  application phase, so that phase is not offered for them."
  [permit-types]
  (let [primary-permit-types (filter ptc-model/primary-permit-types permit-types)]
    ;; Periodic inspections can coexist with any product but do not add an application phase.
    (cond->> selectable-phases
      (and (seq primary-permit-types)
           (every? ptc-model/execution-only-types primary-permit-types))
      (remove #{:group.feature/application-inspections}))))

(defn inspection-phase-selection [{:keys [tr authority-group-id]}]
  (let [group-features  (<sub [::gas/group-features])
        permit-types    (<sub [::gas/group-permit-types])
        licensing?      (contains? permit-types :permit-type/L)
        enabled?        (<sub [::ff/enabled? :feature-flag.id/pre-issuance-inspections])
        selected-phases (->> group-features
                             (filter #(contains? (set selectable-phases) %))
                             set)]
    (when (or licensing? enabled?)
      [:div
       [:h3.w-full.mb-2 (tr [:inspection/phases])]
       [:div.mb-4
        [:div.mb-2.text-xs (tr [:inspection/phases-choice-text])]
        [:div.flex.flex-col
         (for [phase (available-phases permit-types)]
           (let [toggled? (contains? selected-phases phase)]
             [:div {:key (str phase "-toggle-key")}
              [:span (tr [(case phase
                            :group.feature/application-inspections :workspace.state/application
                            :group.feature/execution-inspections :workspace.state/execution)])]
              (cc/toggle {:id         (str phase "-toggle-id")
                          :toggled    toggled?
                          :class-name "mb-3"
                          :labelA     (tr [:0])
                          :labelB     (tr [:1])
                          :on-toggle  #(>evt [::feature-toggle/toggle-group-feature authority-group-id phase (not toggled?)])})]))]]])))
